import { Module } from "wrapper6";

export default class ContactForm extends Module {

	ready(app) {
    var submitWrap = document.querySelector('.wpcf7-submit-wrap');
    var submitButton = document.querySelector('.wpcf7-submit');

    if (submitButton && submitWrap) {
      submitButton.addEventListener('click', showLoader);

      document.addEventListener( 'wpcf7submit', function() {
        hideLoader();
      }, false );
    }

    function showLoader () {
      submitWrap.classList.add('loading');
    }

    function hideLoader () {
      submitWrap.classList.remove('loading');
    }

  }

}
